import {
  IconButton,
  Modal,
  Box,
  Typography,
  TableBody,
  Table,
  TableRow,
  TableCell,
  TableContainer,
  Chip,
  Tooltip,
  Link,
  TableHead,
} from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  Close as CloseIcon,
} from "@mui/icons-material";

import { modalStyle } from "./DomainFinderModal";

import APIFoundDomain from "../../types/APIFoundDomain";

export default function DomainFinderResponseModal({
  foundDomains,
  onBack,
  onExit,
}: {
  foundDomains: APIFoundDomain[];
  onBack: null | (() => void);
  onExit: () => void;
}) {
  return (
    <Modal open={true} onClose={onExit}>
      <Box sx={modalStyle}>
        <Box>
          {onBack !== null && (
            <>
              <IconButton onClick={onBack} color="primary">
                <ArrowBackIcon fontSize="inherit" sx={{ margin: 0 }} />
              </IconButton>{" "}
            </>
          )}
          <IconButton onClick={onExit} color="primary" sx={{ float: "right" }}>
            <CloseIcon fontSize="inherit" sx={{ margin: 0 }} />
          </IconButton>{" "}
        </Box>
        {foundDomains.length === 0 ? (
          <Box sx={{ ml: 1, mr: 1, mt: 2, mb: 2 }}>
            <Typography variant="h5" component="h5" sx={{ mb: 2 }}>
              No domain candidates found.
            </Typography>
            <Box>
              For best results, enter as many fields as possible in the form.
            </Box>
          </Box>
        ) : (
          <TableContainer>
            <Table size="small" aria-label="contact info table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Domain</strong>
                  </TableCell>

                  <TableCell>
                    <strong>Name</strong>
                  </TableCell>

                  <TableCell>
                    <strong>Sources</strong>
                  </TableCell>

                  <TableCell align="right">
                    <strong>Actions</strong>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {foundDomains.map((foundDomain: any) => (
                  <TableRow
                    key={foundDomain.name || foundDomain.domain}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell sx={{ pr: 0 }}>
                      <Link
                        href={`https://${foundDomain.domain}`}
                        target="_blank"
                        rel="noopener"
                      >
                        <Typography variant="subtitle1">
                          {foundDomain.domain}
                        </Typography>
                      </Link>
                    </TableCell>
                    <TableCell sx={{ pr: 0 }}>{foundDomain.name}</TableCell>
                    <TableCell sx={{ pl: 0 }} align="right">
                      {foundDomain.sources.map((source: any) => (
                        <Box
                          key={JSON.stringify(source)}
                          sx={{
                            display:
                              foundDomain.sources.length > 2
                                ? "block"
                                : "inline-block",
                          }}
                        >
                          <Tooltip
                            key={source.type}
                            title={source.type}
                            placement="right"
                            arrow
                          >
                            <Chip
                              sx={{ ml: 1, mt: 0.5 }}
                              label={<Box>{source.type}</Box>}
                              color="info"
                              variant="outlined"
                            />
                          </Tooltip>
                        </Box>
                      ))}
                    </TableCell>
                    <TableCell>
                      <Link
                        href={`${window.location.origin}/domain/${foundDomain.domain}?run=1`}
                        target="_blank"
                      >
                        Run
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Modal>
  );
}
